export default class AssignToAutocomplete {
	constructor(input) {
		this.input = input;

		this.init();
	}

	init() {
		$(this.input)
			.autocomplete({
				position: { at: 'left bottom+10' }
			})
			.autocomplete('instance')._renderItem = function(ul, item) {
				return $('<li>')
					.attr('class', 'suggestion')
					.attr('data-value', item.value)
					.attr('data-label', item.label)
					.append(
						$('<div>')
							.append($('<span>').append(`${item.label} (id: ${item.value})`))
					)
					.appendTo(ul);
			};

		$(this.input).on('input', () => this.loadManagers());
	}

	loadManagers() {
		const searchQuery = this.input.value;
		fetch(this.input.dataset.action + `?search_query=${searchQuery}`)
			.then(
				response => {
					if (response.ok) {
						response.json().then(
							json => {
								const options = [];
								json.result.forEach(item => {
									options.push({
										label: item.full_name,
										value: item.id
									});
								});
								this.setSource(options);
							}
						);
					} else {
						this.setSource([]);
					}
				}
			)
			.catch(() => {
				this.setSource([]);
			});
	}

	setSource(options) {
		$(this.input).autocomplete('option', 'source', function(request, response) {
			const result = options.filter(option => {
				return new RegExp($.ui.autocomplete
					.escapeRegex(request.term))
					.test(option.value);
			});

			response(result);
		});
	}
}
